import { reactivateSubscriptionAction } from 'components/Profile/store'
import { connect } from 'react-redux'
import UI from './UI'

const mapStateToProps = ({ user, support }) => ({
  subscriptionEndDate: user.Subscription?.EndDate,
  contactPhone: support.ContactPhone,
  contactEmail: support.ContactEmail
})

const mapDispatchToProps = dispatch => ({
  reactivateSubscription: () => dispatch(reactivateSubscriptionAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
